import type { SxProps, Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

export const headerNowrapStyles: SxProps<Theme> = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};

type StyleEntry =
  | SystemStyleObject<Theme>
  | ((theme: Theme) => SystemStyleObject<Theme>);

export const styles = {
  tablePrimary: (theme) => ({
    width: '100%',
    '& .MuiTableCell-stickyHeader': {
      color: `${theme.palette.table.textHeader}`,
      backgroundColor: `${theme.palette.table.main}`,
      padding: '8px',
      position: 'sticky !important',
      top: 0,
      zIndex: 1000,
    },
  }),
  tableSecondary: (theme) => ({
    width: '100%',
    '& .MuiTableCell-stickyHeader': {
      color: `${theme.palette.table.textHeaderSecondary}`,
      backgroundColor: `${theme.palette.table.secondary}`,
      padding: '8px',
      position: 'sticky !important',
      top: 0,
      zIndex: 1000,
    },
  }),
  tableRow: (theme) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: `${theme.palette.common.white} !important`,
    },
  }),
  tableCell: {
    fontWeight: 'normal',
    fontSize: '0.8rem',
  },
  tableCell2: {
    fontWeight: 'normal',
  },
  headerStatic: {
    position: 'sticky',
    top: 0,
  },
  cellsCompact: {
    minWidth: 'auto',
    whiteSpace: 'nowrap',
  },
  fixedColumn: {
    position: 'sticky',
    left: 0,
    zIndex: 10,
  },
  hover: (theme) => ({
    '&:hover': {
      backgroundColor: `${theme.palette.table.hover} !important`,
      '& .MuiTableCell-body': {
        backgroundColor: `${theme.palette.table.hover} !important`,
      },
    },
  }),
  formControlLabelCheckox: {
    margin: 0,
    '& .MuiCheckbox-root': {
      padding: 0,
    },
  },
  fullscreen: {
    height: 'calc(100vh - 90px)',
    width: 'calc(100vw - 50px)',
    position: 'fixed',
    top: 0,
    left: '50px',
    zIndex: 999,
  },
  tableDetailRow: (theme) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.common.white,
    },
  }),
  eventCell: {
    cursor: 'pointer',
  },
} satisfies Record<string, StyleEntry>;
